import { getPersonioAttendanceTypeTranslationKey } from "../integrations/get-personio-attendance-type-translation-key";
import type { TranslationKey } from "../locales";
import type { AttendanceListItem } from "../types";

/**
 * The label an entry reads as: work, a break, or an automatic break — the rest a check-out
 * recorded to meet the legal minimum, named apart so nobody takes it for a break they clocked.
 *
 * @param attendance - The entry's kind, and whether a check-out wrote it.
 * @returns The translation key of the label.
 */
export function getAttendanceTypeTranslationKey(
	attendance: Pick<AttendanceListItem, "type" | "isAutomatic">,
): TranslationKey {
	if (attendance.isAutomatic) return "users.attendance_type.automatic_break";
	return getPersonioAttendanceTypeTranslationKey(attendance.type);
}
